import type { BookId, Catalog, PropsRow, WhalesSide, WhalesSummary, WhalesTopic } from "@/lib/odds-screen/live/types";
import { sportsbookIdToDisplay, type SportsbookId } from "@/lib/sportsbook-registry";
import type { BookWeights } from "@/lib/weights-config";

export const WHALES_COLUMN = "whales";

export const WHALES_LOCKED_LABEL = "Whales, Diamond only";

export type ComparisonColumnId = SportsbookId | typeof WHALES_COLUMN;

export function comparisonColumnLabel(id: string): string {
  return id === WHALES_COLUMN ? "Whales" : sportsbookIdToDisplay(id);
}

export type SideNames = { readonly side: string | null; readonly other: string | null };

export type RowWhales = { readonly topic: WhalesTopic; readonly side: string; readonly summary: WhalesSummary; readonly book: BookId };

export type WhalesSpec = { readonly cell: RowWhales; readonly which: "side" | "opp"; readonly line: string | null };

function ownSide([first, second]: WhalesSummary, side: string): WhalesSide | null {
  return first.name === side ? first : second.name === side ? second : null;
}

export function whalesSide({ cell, which }: WhalesSpec): WhalesSide | null {
  const own = ownSide(cell.summary, cell.side);
  if (own === null) return null;
  const [first, second] = cell.summary;
  return which === "side" ? own : own === first ? second : first;
}

export function venueLeftOut(book: BookId, books: Catalog["books"] | undefined): BookId {
  return books?.get(book)?.resells ?? book;
}

export function whalesFair(row: Pick<PropsRow, "side" | "whales">): number | null {
  return row.whales === null ? null : ownSide(row.whales, row.side.toLowerCase())?.fair ?? null;
}

export function withoutWhales(weights: BookWeights): BookWeights | null {
  if (!(WHALES_COLUMN in weights)) return weights;
  const books = { ...weights };
  delete books[WHALES_COLUMN];
  return Object.keys(books).length > 0 ? books : null;
}
